export default "__VITE_ASSET__DgeCpf$m__"